// extracted by mini-css-extract-plugin
export default {"group":"FacetGroup_group__ty9Ap","facets":"FacetGroup_facets__dNXpd","title":"FacetGroup_title__NJzT0"};